module.exports = __webpack_public_path__ + "static/media/1.0b8ddae9.jpg";